import { SyncedInput } from "@/components/SyncedInput";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Badge } from "@/components/ui/badge";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { ORDER_STATUS, ORDER_BADGE, eur, fmtDate } from "./salesShared";
import { Trash2, Building2, Package } from "lucide-react";

export default function OrdersTab({ orders, reload }) {
  const setStatus = async (o, status) => { try { await api.put(`/sales/orders/${o.id}`, { ...o, status }); reload(); } catch (e) { toast.error(formatApiError(e)); } };
  const setNotitie = async (o, notitie) => { try { await api.put(`/sales/orders/${o.id}`, { ...o, notitie }); } catch (e) { toast.error(formatApiError(e)); } };
  const del = async (o) => { if (!window.confirm(`Order ${o.offertenummer || ""} verwijderen?`)) return; try { await api.delete(`/sales/orders/${o.id}`); reload(); } catch (e) { toast.error(formatApiError(e)); } };

  const sorted = [...orders].sort((a, b) => String(b.datum || "").localeCompare(String(a.datum || "")));
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-bold text-slate-800">Orders <span className="text-slate-400 font-normal">({orders.length})</span></h2>
      <p className="text-sm text-slate-500">Orders ontstaan uit een <b>geaccepteerde offerte</b> (knop "Maak order" op het Offertes-tabblad). Volg hier de status.</p>
      <div className="space-y-2">
        {orders.length === 0 && <p className="text-sm text-slate-400">Nog geen orders.</p>}
        {sorted.map((o) => (
          <div key={o.id} data-testid="order-row" className="rounded-lg border border-slate-200 bg-white p-3">
            <div className="flex flex-wrap items-center gap-3">
              <Badge className="bg-[#1C64B0] text-white font-mono" data-testid="order-nr"><Package className="h-3 w-3 mr-1" />{o.offertenummer || "—"}</Badge>
              <div className="flex-1 min-w-[180px]">
                <div className="font-semibold text-slate-800 inline-flex items-center gap-2"><Building2 className="h-4 w-4 text-slate-400" /> {o.klantNaam || o.klantCode} <span className="text-slate-400 font-normal text-sm">· {fmtDate(o.datum)}</span></div>
                <div className="text-xs text-slate-500 mt-0.5">{(o.regels || []).length} regel(s) · Totaal {eur(o.totaal ?? 0)}</div>
              </div>
              <Badge className={ORDER_BADGE[o.status] || "bg-slate-100 text-slate-600"}>{o.status || "Nieuw"}</Badge>
              <Select value={o.status || "Nieuw"} onValueChange={(v) => setStatus(o, v)}><SelectTrigger data-testid="order-status" className="w-40 h-8"><SelectValue /></SelectTrigger><SelectContent>{ORDER_STATUS.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent></Select>
              <Button variant="ghost" size="icon" className="h-8 w-8" data-testid="order-delete" onClick={() => del(o)}><Trash2 className="h-4 w-4 text-slate-400" /></Button>
            </div>
            <SyncedInput as={Textarea} data-testid="order-notitie" rows={1} defaultValue={o.notitie || ""} onBlur={(e) => setNotitie(o, e.target.value)} placeholder="Interne notitie / productieopmerking…" className="mt-2 text-sm" />
          </div>
        ))}
      </div>
    </div>
  );
}
